import { RiPlayCircleLine } from '@remixicon/react';

import {
  type ToolGroupEntry,
  createToolExtension,
  mcpTool,
} from '@spotify/plugin-confidence-chat-react';

import { recordingsPlugin } from '../plugin';
import { RecordingsTable } from './RecordingsTable';
import { parseSearchResult } from './searchResult';

const MAX_PREVIEWS = 10;

// Transitional fallback for results from agent versions that predate the
// fenced recordings block. Results marked presentation="block" are composed
// by the agent via ```recordings in its reply (see RecordingsCodeBlock), so
// the tool site renders only its label row.
export const RecordingToolFallback = ({ entry }: { entry: ToolGroupEntry }) => {
  const result = parseSearchResult(entry.result?.content);
  if (!result || result.presentation === 'block') return null;

  const recordings = result.recordings
    .filter(r => r.preview)
    .slice(0, MAX_PREVIEWS);
  if (recordings.length === 0) return null;

  return <RecordingsTable recordings={recordings} />;
};

export const RecordingToolExtension = recordingsPlugin.provide(
  createToolExtension({
    id: 'recording-preview',
    predicate: mcpTool('semantic_search_recordings'),
    icon: RiPlayCircleLine,
    display: 'prominent',
    render: () => null,
    renderTool: entry => <RecordingToolFallback entry={entry} />,
  }),
);
